module.exports = __webpack_public_path__ + "static/img/4.0389ebf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/zh/4.png
// module id = Zte2
// module chunks = 0